(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-pdp-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.tm-faq__item').forEach(function (item) {
      var btn = item.querySelector('.tm-faq__q');
      if (btn) btn.addEventListener('click', function () { item.classList.toggle('is-open'); });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-pdp-trust]').forEach(function (el) {
      var raw = el.getAttribute('data-pdp-trust') || '';
      var msgs = raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!msgs.length) { msgs = ['✓ COD Available','✓ Free Shipping Rs.5,999+','✓ 14-Day Easy Returns','✓ Delivery in 3–5 Days','✓ 45,000+ Happy Customers']; }
      if (msgs.length < 2) { el.textContent = msgs[0] || ''; return; }
      var idx = 0;
      setInterval(function () {
        el.style.opacity = '0';
        setTimeout(function () { idx = (idx + 1) % msgs.length; el.textContent = msgs[idx]; el.style.opacity = '1'; }, 300);
      }, parseInt(el.getAttribute('data-pdp-trust-speed'), 10) || 2000);
    });

    /* Viewer count — per-product session seed */
    (function () {
      try {
        var el = document.querySelector('[data-pdp-viewers]');
        if (!el) return;
        var productId = el.dataset.productId || 'x';
        var key = 'tm_vseed_' + productId;
        var seed = parseInt(sessionStorage.getItem(key) || '0', 10);
        if (!seed) {
          seed = Math.floor(Math.random() * 19) + 4;
          sessionStorage.setItem(key, seed);
        }
        var drift = Math.floor(Date.now() / 30000) % 3;
        el.textContent = Math.max(1, seed + drift) + ' viewing';
        setInterval(function () {
          drift = Math.floor(Date.now() / 30000) % 3;
          el.textContent = Math.max(1, seed + drift) + ' viewing';
        }, 30000);
      } catch (e) {}
    })();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    /* CHANGE 1: Trust strip rotator */
    document.querySelectorAll('[data-pdp-trust]').forEach(function (el) {
      var msgs = [
        '✓ COD Available',
        '✓ Free Shipping Rs.5,999+',
        '✓ 14-Day Easy Returns',
        '✓ Delivery in 3–5 Days',
        '✓ 2,604+ Happy Customers'
      ];
      var idx = 0;
      setInterval(function () {
        el.style.opacity = '0';
        setTimeout(function () {
          idx = (idx + 1) % msgs.length;
          el.textContent = msgs[idx];
          el.style.opacity = '1';
        }, 300);
      }, 2000);
    });

    /* Viewer count — per-product session seed so same product shows consistent number */
    (function () {
      try {
        var el = document.querySelector('[data-pdp-viewers]');
        if (!el) return;
        var productId = el.dataset.productId || 'x';
        var key = 'tm_vseed_' + productId;
        var seed = parseInt(sessionStorage.getItem(key) || '0', 10);
        if (!seed) {
          seed = Math.floor(Math.random() * 19) + 4;
          sessionStorage.setItem(key, seed);
        }
        var drift = Math.floor(Date.now() / 30000) % 3;
        var count = Math.max(1, seed + drift);
        el.textContent = count + ' viewing';
        setInterval(function () {
          drift = Math.floor(Date.now() / 30000) % 3;
          el.textContent = Math.max(1, seed + drift) + ' viewing';
        }, 30000);
      } catch (e) {}
    })();

    /* FAQ accordion */
    document.querySelectorAll('.pdp-faq__item').forEach(function (item) {
      var btn = item.querySelector('.pdp-faq__q');
      if (btn) btn.addEventListener('click', function () { item.classList.toggle('is-open'); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
